import { postServiceCollection } from "../../actions/api";
import React, { useState } from "react";
import { Button, Form, Input, Modal, Tooltip } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { PlusSquareOutlined } from "@ant-design/icons";

const ServiceCollectionCreateModal = ({
  postServiceCollection,
  isAdmin = false,
}) => {
  const [visible, setVisible] = useState(false);
  const title = "Create a new Service Collection";
  const [form] = Form.useForm();
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const openUpdateModal = (e) => {
    e.preventDefault();
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const onFinish = async (values) => {
    await postServiceCollection(values);
    setVisible(false);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Tooltip title={title}>
        <Button
          id="createServiceCollection"
          onClick={openUpdateModal}
          disabled={!isAdmin}
          icon={<PlusSquareOutlined />}
        >
          Create
        </Button>
      </Tooltip>
      <Modal
        style={{ minWidth: "90%" }}
        centered
        title={title}
        open={visible}
        onOk={form.submit}
        okText="Save"
        onCancel={handleCancel}
      >
        <p>
          An application will be created for you where you can define
          subscription and eligible roles.
        </p>
        <Form
          {...layout}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ maxWidth: 600, marginTop: "10px" }}
        >
          <Form.Item label="Identifier" name="applicationIdentifier">
            <Input placeholder="application-identifier" />
          </Form.Item>
          <Form.Item label="Display Name" name="displayName">
            <Input placeholder="Display Name" />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input placeholder="Description" />
          </Form.Item>
          {/* <Form.Item>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item> */}
        </Form>
      </Modal>
    </>
  );
};

ServiceCollectionCreateModal.propTypes = {
  postServiceCollection: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
};

export default connect(() => ({}), { postServiceCollection })(
  ServiceCollectionCreateModal,
);
